export default {
  setForm: (state, payload) => {
    state = Object.assign(state, payload); // { ...payload };
  },
  /**
   * Dùng để cập nhập bước duyệt
   */
  updateApproval: (state, payload) => {
    // state = Object.assign(state, payload);
    state.approvalStatus = payload.approvalStatus;
    state.approvalCurrentStep = payload.approvalCurrentStep;
    state.approvalTotalStep = payload.approvalTotalStep;
    state.currentApprovalStep = payload.currentApprovalStep;
    console.log("đã duyệt", state);
  }
};
